"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const React = require("react");
require("./Spinner.scss");
/**
 * Purely visual spinning indicator. Styling (two-tone ring, eased spin) is
 * ported from Fluent UI's Spinner component - see Spinner.scss - simplified
 * to our fixed size scale since we don't depend on Fluent itself.
 */
class Spinner extends React.PureComponent {
    render() {
        const size = this.props.size || "2";
        return (React.createElement("div", { className: `spinner size-${size}x`, role: "presentation" },
            React.createElement("div", { className: "spinner-circle" })));
    }
}
exports.Spinner = Spinner;
